import React from "react";

const ActivityEmployee = () => {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        color: "#000",
        height: "100px",
        fontSize: "20px",
        padding: "10px",
        margin: "10px",
      }}
    >
      No activity by the user.
    </div>
  );
};

export default ActivityEmployee;
